// Auto-generated enum types and metadata
// DO NOT EDIT - Changes will be overwritten

export enum BusinessRole {
  UNKNOWN = "Unknown",
  BUSINESS_ANALYSIS = "Business Analysis",
  CUSTOMER_SERVICE = "Customer Service",
  ELECTRONIC_ENGINEERING = "Electronic Engineering",
  ENVIRONMENTAL_ENGINEERING = "Environmental Engineering",
  HUMAN_RESOURCES = "Human Resources",
  INDUSTRIAL_DESIGN = "Industrial Design",
  INVENTORY_MANAGEMENT = "Inventory Management",
  LOGISTICS = "Logistics",
  MAINTENANCE_ENGINEERING = "Maintenance Engineering",
  MANUFACTURING = "Manufacturing",
  MARKETING = "Marketing",
  MECHANICAL_ENGINEERING = "Mechanical Engineering",
  OPERATIONS = "Operations",
  PROCESS_ENGINEERING = "Process Engineering",
  PRODUCT_DESIGN = "Product Design",
  PROCUREMENT = "Procurement",
  PRODUCTION_ENGINEERING = "Production Engineering",
  PROJECT_MANAGEMENT = "Project Management",
  QUALITY_CONTROL = "Quality Control",
  REGULATORY_AFFAIRS = "Regulatory Affairs",
  RESEARCH_AND_DEVELOPMENT = "Research and Development",
  SAFETY_ENGINEERING = "Safety Engineering",
  SALES = "Sales",
  SOFTWARE_ENGINEERING = "Software Engineering",
  SOURCING = "Sourcing",
  SUPPLY_CHAIN_MANAGEMENT = "Supply Chain Management",
  SYSTEM_ENGINEERING = "Systems Engineering",
  TECHNICAL_SUPPORT = "Technical Support",
  TESTING_AND_VALIDATION = "Testing and Validation",
}

export enum ChatRoleType {
  SYSTEM_UI = "system_ui",
  SYSTEM = "system",
  USER = "user",
  AGENT = "agent",
  FEEDBACK_REQUEST = "feedback_request",
  FEEDBACK_REQUEST_ERROR = "feedback_request_error",
  ERROR = "error",
}

export enum DevelopmentStage {
  CONCEPT = "concept",
  DESIGN = "design",
  PROTOTYPE = "prototype",
  TESTING = "testing",
  PRODUCTION = "production",
}

export enum InviteStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  DECLINED = "declined",
  REVOKED = "revoked",
}

export enum OrgType {
  NO_ORG = "NO_ORG",
  AFTERMARKET_PROVIDER = "Aftermarket Provider",
  ARCHITECTURE = "Architecture",
  CONSTRUCTION = "Construction",
  CONTRACT_MANUFACTURER = "Contract Manufacturer",
  DISTRIBUTOR = "Distributor",
  ENGINEERING_CONSULTANCY = "Engineering Consultancy",
  IMPORT_EXPORT = "Import/Export",
  LOGISTICS_PROVIDER = "Logistics Provider",
  MAINTENANCE = "Maintenance",
  MANUFACTURER = "Manufacturer",
  ODM = "Original Design Manufacturer",
  OEM = "Original Equipment Manufacturer",
  PROCUREMENT_AGENCY = "Procurement Agency",
  PRODUCT_COMPANY = "Product Company",
  QUALITY_INSPECTION = "Quality Inspection",
  RECYCLING = "Recycling",
  RESEARCH_AND_DEVELOPMENT = "Research and Development",
  RETAILER = "Retailer",
  SUPPLIER = "Supplier",
  SYSTEM_INTEGRATOR = "System Integrator",
  TESTING_AND_CERTIFICATION = "Testing and Certification",
  WHOLESALER = "Wholesaler",
}

export enum Priority {
  CRITICAL = 1,
  HIGH = 2,
  MEDIUM = 3,
  LOW = 4,
  NICE_TO_HAVE = 5,
}

export const PriorityMetadata = {
  CRITICAL: {
    value: 1,
    description: "Must have, blocks progress",
    examples: [],
    color: "bg-red-100 text-red-800",
  },
  HIGH: {
    value: 2,
    description: "Very important, high impact",
    examples: [],
    color: "bg-orange-100 text-orange-800",
  },
  MEDIUM: {
    value: 3,
    description: "Important, moderate impact",
    examples: [],
    color: "bg-yellow-100 text-yellow-800",
  },
  LOW: {
    value: 4,
    description: "Nice to have, low impact",
    examples: [],
    color: "bg-green-100 text-green-800",
  },
  NICE_TO_HAVE: {
    value: 5,
    description: "Optional, minimal impact",
    examples: [],
    color: "bg-gray-100 text-gray-800",
  },
} as const;

export type PriorityMetadataType = typeof PriorityMetadata;

export enum RequirementStatus {
  TBA = "TBA",
  OK = "OK",
  WARNING = "WARNING",
  ERROR = "ERROR",
}

export const RequirementStatusMetadata = {
  TBA: {
    value: "TBA",
    description: "To be analyzed - awaiting review",
    examples: [],
    color: "bg-gray-100 text-gray-800",
  },
  OK: {
    value: "OK",
    description: "Validated and approved",
    examples: [],
    color: "bg-green-100 text-green-800",
  },
  WARNING: {
    value: "WARNING",
    description: "Needs review or attention",
    examples: [],
    color: "bg-amber-100 text-amber-800",
  },
  ERROR: {
    value: "ERROR",
    description: "Invalid or rejected",
    examples: [],
    color: "bg-red-100 text-red-800",
  },
} as const;

export type RequirementStatusMetadataType = typeof RequirementStatusMetadata;

export enum RequirementType {
  FUNCTIONAL = "Functional",
  PERFORMANCE = "Performance",
  MATERIAL = "Material",
  DIMENSIONAL_AND_GEOMETRIC = "Dimensional and Geometric",
  INTERFACE = "Interface",
  RELIABILITY_AND_DURABILITY = "Reliability and Durability",
  ENVIRONMENTAL_AND_OPERATING = "Environmental and Operating",
  SAFETY = "Safety",
  COMPLIANCE_AND_REGULATORY = "Compliance and Regulatory",
  MANUFACTURING_AND_ASSEMBLY = "Manufacturing and Assembly",
  MAINTENANCE_AND_SERVICEABILITY = "Maintenance and Serviceability",
  AESTHETIC = "Aesthetic",
  PACKAGING_AND_SHIPPING = "Packaging and Shipping",
  COST_AND_BUDGET = "Cost and Budget",
  WEIGHT_AND_STRUCTURAL = "Weight and Structural",
  LIFECYCLE = "Lifecycle",
}

export const RequirementTypeMetadata = {
  FUNCTIONAL: {
    value: "Functional",
    description: "Primary purpose and functionality the component must perform",
    examples: ["Motor must rotate at 3000 RPM", "System must process 100 requests/second", "Drone must maintain stable hover"],
    color: "bg-blue-100 text-blue-800",
    icon: "cog",
    promptContext: "Focus on what the system DOES, not how it's built",
  },
  PERFORMANCE: {
    value: "Performance",
    description: "Measurable performance targets and operational metrics",
    examples: ["Response time < 200ms", "Efficiency > 95%", "Maximum speed: 150 mph"],
    color: "bg-green-100 text-green-800",
    icon: "chart-bar",
    promptContext: "Must be quantifiable and testable",
  },
  MATERIAL: {
    value: "Material",
    description: "Material specifications and properties",
    examples: ["Housing material: Aluminum alloy 6061-T6", "PCB substrate: FR-4 with 2oz copper", "Seal material: Viton for chemical resistance"],
    color: "bg-purple-100 text-purple-800",
    icon: "cube",
  },
  DIMENSIONAL_AND_GEOMETRIC: {
    value: "Dimensional and Geometric",
    description: "Size, shape, and geometric tolerances",
    examples: ["Maximum dimensions: 100mm x 50mm x 20mm", "Hole diameter: 10mm ±0.1mm", "Surface flatness: 0.05mm"],
    color: "bg-amber-100 text-amber-800",
    icon: "ruler",
  },
  INTERFACE: {
    value: "Interface",
    description: "Connection points and compatibility requirements",
    examples: ["USB-C port for data transfer", "M8 threaded mounting holes", "Compatible with ISO 9001 standard interfaces"],
    color: "bg-cyan-100 text-cyan-800",
    icon: "plug",
  },
  RELIABILITY_AND_DURABILITY: {
    value: "Reliability and Durability",
    description: "Lifespan, failure rates, and robustness",
    examples: ["MTBF > 10,000 hours", "Operating life: 5 years minimum", "Withstand 1000 cycles of operation"],
    color: "bg-red-100 text-red-800",
    icon: "shield-check",
  },
  ENVIRONMENTAL_AND_OPERATING: {
    value: "Environmental and Operating",
    description: "Operating conditions and environmental resistance",
    examples: ["Operating temperature: -40°C to +85°C", "IP67 water and dust protection", "Humidity: 0-95% non-condensing"],
    color: "bg-lime-100 text-lime-800",
    icon: "thermometer",
  },
  SAFETY: {
    value: "Safety",
    description: "Safety standards and hazard mitigation requirements",
    examples: ["Comply with IEC 61508 SIL 2", "Emergency stop within 2 seconds", "No exposed voltages above 48V"],
    color: "bg-rose-100 text-rose-800",
    icon: "exclamation-triangle",
  },
  COMPLIANCE_AND_REGULATORY: {
    value: "Compliance and Regulatory",
    description: "Legal and regulatory conformance requirements",
    examples: ["CE marking for European market", "FCC Part 15 Class B compliance", "RoHS compliant materials"],
    color: "bg-violet-100 text-violet-800",
    icon: "clipboard-check",
  },
  MANUFACTURING_AND_ASSEMBLY: {
    value: "Manufacturing and Assembly",
    description: "Production process constraints and assembly requirements",
    examples: ["Compatible with SMT assembly process", "No manual soldering required", "Design for injection molding"],
    color: "bg-pink-100 text-pink-800",
    icon: "tools",
  },
  MAINTENANCE_AND_SERVICEABILITY: {
    value: "Maintenance and Serviceability",
    description: "Service intervals and maintainability features",
    examples: ["Tool-free battery replacement", "Service interval: 6 months", "Modular design for component replacement"],
    color: "bg-orange-100 text-orange-800",
    icon: "wrench",
  },
  AESTHETIC: {
    value: "Aesthetic",
    description: "Visual design and appearance requirements",
    examples: ["Matte black finish", "Logo placement per brand guidelines", "Smooth edges with 2mm radius"],
    color: "bg-fuchsia-100 text-fuchsia-800",
    icon: "palette",
  },
  PACKAGING_AND_SHIPPING: {
    value: "Packaging and Shipping",
    description: "Transportation and storage requirements",
    examples: ["Withstand 1.5m drop test", "Stackable packaging design", "Include desiccant for moisture control"],
    color: "bg-emerald-100 text-emerald-800",
    icon: "box",
  },
  COST_AND_BUDGET: {
    value: "Cost and Budget",
    description: "Cost targets and budget constraints",
    examples: ["Unit cost < $50", "Development budget: $100,000", "Annual maintenance cost < $1,000"],
    color: "bg-yellow-100 text-yellow-800",
    icon: "dollar-sign",
  },
  WEIGHT_AND_STRUCTURAL: {
    value: "Weight and Structural",
    description: "Weight limits and structural load requirements",
    examples: ["Maximum weight: 2.5 kg", "Support 100kg vertical load", "Withstand 5g acceleration"],
    color: "bg-indigo-100 text-indigo-800",
    icon: "weight",
  },
  LIFECYCLE: {
    value: "Lifecycle",
    description: "End-of-life disposal and recyclability requirements",
    examples: ["95% recyclable materials", "Battery removal for separate disposal", "No hazardous materials requiring special disposal"],
    color: "bg-teal-100 text-teal-800",
    icon: "recycle",
  },
} as const;

export type RequirementTypeMetadataType = typeof RequirementTypeMetadata;

export enum SubTaskType {
  DELEGATION = "delegation",
  ISOLATED = "isolated",
  CONTEXT_ONLY = "context_only",
}

export enum SupplyChainCriteriaType {
  COST_AND_PRICING = "Cost and Pricing",
  QUALITY_AND_COMPLIANCE = "Quality and Compliance",
  LEAD_TIME_AND_DELIVERY = "Lead Time and Delivery Performance",
  CAPACITY_AND_SCALABILITY = "Capacity and Scalability",
  VISIBILITY_AND_TRANSPARENCY = "Supply Chain Visibility and Transparency",
  FINANCIAL_STABILITY = "Financial Stability and Reputation",
  RISK_MANAGEMENT = "Risk Management and Resilience",
  SUSTAINABILITY = "Sustainability and Environmental Practices",
  INNOVATION_AND_TECHNOLOGY = "Innovation and Technology",
  CUSTOMER_SERVICE = "Customer Service and Communication",
  CULTURAL_FIT = "Cultural Fit and Relationship Management",
  GEOPOLITICAL_REGULATORY = "Geopolitical and Regulatory Considerations",
  AFTER_SALES_SUPPORT = "After-Sales Support and Service",
  ETHICAL_RESPONSIBILITY = "Ethical and Social Responsibility",
}

export const SupplyChainCriteriaTypeMetadata = {
  COST_AND_PRICING: {
    value: "Cost and Pricing",
    description: "Total cost of ownership and pricing structures",
    examples: ["Unit price < $10 for orders > 10,000", "Volume discounts available", "Payment terms: Net 30"],
    color: "bg-yellow-100 text-yellow-800",
    icon: "dollar-sign",
  },
  QUALITY_AND_COMPLIANCE: {
    value: "Quality and Compliance",
    description: "Quality standards and compliance requirements",
    examples: ["ISO 9001:2015 certified", "Zero defect rate requirement", "IPC-A-610 Class 2 workmanship"],
    color: "bg-green-100 text-green-800",
    icon: "check-circle",
  },
  LEAD_TIME_AND_DELIVERY: {
    value: "Lead Time and Delivery Performance",
    description: "Production lead times and delivery performance",
    examples: ["Standard lead time: 4 weeks", "On-time delivery rate > 98%", "Express shipping available"],
    color: "bg-blue-100 text-blue-800",
    icon: "clock",
  },
  CAPACITY_AND_SCALABILITY: {
    value: "Capacity and Scalability",
    description: "Production capacity and ability to scale",
    examples: ["Minimum capacity: 10,000 units/month", "Ability to scale to 50,000 units/month", "Dedicated production line available"],
    color: "bg-purple-100 text-purple-800",
    icon: "trending-up",
  },
  VISIBILITY_AND_TRANSPARENCY: {
    value: "Supply Chain Visibility and Transparency",
    description: "Supply chain visibility and transparency requirements",
    examples: ["Real-time order tracking", "Monthly inventory reports", "Supply chain mapping to Tier 2"],
    color: "bg-cyan-100 text-cyan-800",
    icon: "eye",
  },
  FINANCIAL_STABILITY: {
    value: "Financial Stability and Reputation",
    description: "Financial health and business stability",
    examples: ["Dun & Bradstreet rating > 3", "5+ years in business", "Annual revenue > $10M"],
    color: "bg-emerald-100 text-emerald-800",
    icon: "trending-down",
  },
  RISK_MANAGEMENT: {
    value: "Risk Management and Resilience",
    description: "Risk mitigation and resilience capabilities",
    examples: ["Dual sourcing capability", "Business continuity plan in place", "Insurance coverage for supply disruptions"],
    color: "bg-red-100 text-red-800",
    icon: "shield-alert",
  },
  SUSTAINABILITY: {
    value: "Sustainability and Environmental Practices",
    description: "Environmental and sustainability practices",
    examples: ["Carbon neutral operations", "100% renewable energy usage", "Sustainable packaging materials"],
    color: "bg-lime-100 text-lime-800",
    icon: "leaf",
  },
  INNOVATION_AND_TECHNOLOGY: {
    value: "Innovation and Technology",
    description: "Technical capabilities and innovation",
    examples: ["R&D investment > 5% of revenue", "Patent portfolio in relevant areas", "Collaborative product development"],
    color: "bg-indigo-100 text-indigo-800",
    icon: "lightbulb",
  },
  CUSTOMER_SERVICE: {
    value: "Customer Service and Communication",
    description: "Support and communication capabilities",
    examples: ["24/7 technical support", "Dedicated account manager", "Response time < 4 hours"],
    color: "bg-pink-100 text-pink-800",
    icon: "headphones",
  },
  CULTURAL_FIT: {
    value: "Cultural Fit and Relationship Management",
    description: "Organizational alignment and partnership approach",
    examples: ["Aligned values and mission", "Collaborative problem-solving", "Long-term partnership focus"],
    color: "bg-orange-100 text-orange-800",
    icon: "handshake",
  },
  GEOPOLITICAL_REGULATORY: {
    value: "Geopolitical and Regulatory Considerations",
    description: "Geopolitical and regulatory considerations",
    examples: ["No operations in sanctioned countries", "ITAR compliance capability", "Export license management"],
    color: "bg-rose-100 text-rose-800",
    icon: "globe",
  },
  AFTER_SALES_SUPPORT: {
    value: "After-Sales Support and Service",
    description: "Post-sale support and service capabilities",
    examples: ["5-year warranty support", "Spare parts availability", "Field service network"],
    color: "bg-violet-100 text-violet-800",
    icon: "wrench",
  },
  ETHICAL_RESPONSIBILITY: {
    value: "Ethical and Social Responsibility",
    description: "Ethical and social responsibility standards",
    examples: ["No child labor in supply chain", "Fair trade certified", "Conflict minerals compliance"],
    color: "bg-fuchsia-100 text-fuchsia-800",
    icon: "heart",
  },
} as const;

export type SupplyChainCriteriaTypeMetadataType = typeof SupplyChainCriteriaTypeMetadata;
